import {css} from '@emotion/react'

import LinkedIn from '../images/browser/social/linkedin.svg'
import Twitter from '../images/browser/social/twitter.svg'
import Mastodon from '../images/browser/social/mastodon.svg'
// import Discord from '../images/browser/social/discord.svg'
import {colors} from '../constants'

const defaultSocialIconsData = [
    {
        url: `https://www.linkedin.com/company/startpage.com/mycompany/`,
        icon: LinkedIn,
        label: `linkedin`,
    },
    {
        url: `https://twitter.com/startpage`,
        icon: Twitter,
        label: `twitter`,
    },
    {
        url: `https://mastodon.social/@StartpageSearch`,
        icon: Mastodon,
        label: `mastodon`,
    },
    // Removing Discord until we have created an actual discord for the browser.
    // {
    //     url: `https://discord.com/invite/PKEBCm7bUV`,
    //     icon: Discord,
    //     label: `discord`,
    // },
]

const SocialIcons = ({socialIconsData = defaultSocialIconsData}) => {
    return (
        <div
            className="social-icons"
            css={css`
                display: flex;
                gap: 12px;
            `}
        >
            {socialIconsData.map(({url, icon, label}, i) => {
                return (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={label}
                        key={i}
                        css={css`
                            height: 32px;
                            width: 32px;
                            svg {
                                height: 100%;
                                width: 100%;
                                &:hover {
                                    circle {
                                        fill: ${colors.brandBlueLight};
                                    }
                                }
                            }
                        `}
                    >
                        {icon()}
                    </a>
                )
            })}
        </div>
    )
}

export default SocialIcons
